import { UmbracoTypes } from '~/lib/data-contract';
import { ModuleContainer } from '../../shared/ModuleContainer';

import { StyledM110TallySplit } from './styled';
import { weakKey } from '~/shared/utils/jsx';
import { M110Tally } from '../M110Tally/M110Tally';
import M100RichText from '../M100RichText';
import M70Media from '../M70Media';
import { ModuleTypes } from '~/lib/data-contract/umbraco-api-model';

type M110TallySplit = UmbracoTypes.IM110TallySplitModule;

export const M110TallySplit = (props: M110TallySplit) => {
    return (
        <ModuleContainer hasGutter>
            <StyledM110TallySplit>
                {props.items?.map((item) =>
                    item.alias === ModuleTypes.IM110TallyModule ? (
                        <M110Tally {...(item as UmbracoTypes.IM110TallyModule)} key={weakKey(item)} />
                    ) : item.alias === ModuleTypes.IM100RichTextModule ? (
                        <M100RichText {...(item as UmbracoTypes.IM100RichTextModule)} key={weakKey(item)} />
                    ) : item.alias === ModuleTypes.IM70MediaModule ? (
                        <M70Media {...(item as UmbracoTypes.IM70MediaModule)} key={weakKey(item)} />
                    ) : null,
                )}
            </StyledM110TallySplit>
        </ModuleContainer>
    );
};
